<template>
  <!-- Navbar -->
  <!-- https://www.creative-tim.com/learning-lab/tailwind-starter-kit/presentation -->

  <nav
    class="z-10 bg-transparent md:flex-row md:flex-no-wrap md:justify-start flex items-center px-4 py-2"
  >
    <div
      class="w-full mx-auto items-center flex flex-row-reverse justify-between md:flex-no-wrap flex-wrap "
    > 
    
    <div id="right_navbar" class="flex flex-row-reverse">

      <!-- User -->
      <ul class="flex-col md:flex-row list-none items-center hidden md:flex">
        <BaseDropDown
          v-on:logout="logout"
          v-bind:items="[
            {
              route: 'profile',
              label: 'Profile',
            },
            {
              event: 'logout',
              label: 'Logout',
            },
          ]"
        >
          <template v-slot:button>
            <div class="items-center flex">
              <span
                class="w-8 h-8 text-sm text-gray-400 hover:text-gray-500 inline-flex items-center justify-center rounded-full"
              >
                <svg-icon
                  icon="heroicons/solid/user-circle"
                  class="h-8 w-8"
                ></svg-icon>
              </span>
            </div>
          </template>

          <template v-slot:header>
            <div class="text-sm font-semibold py-2 px-4">
              {{ user.email }}
            </div>

            <div class="border border-solid border-gray-200"></div>
          </template>
        </BaseDropDown>
      </ul>

      <slot name="right"></slot></div>

      <div id="left_navbar">  <slot name="left"></slot> </div>
     

    </div>
  </nav>

      <!-- Form -->
      <!--
      <form
        class="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3"
      >
        <div class="relative flex w-full flex-wrap items-stretch">
          <span
            class="z-10 h-full leading-snug font-normal absolute text-center text-gray-400 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"
            ><i class="fas fa-search"></i
          ></span>
          <input
            type="text"
            placeholder="Search here..."
            class="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>
      </form>
  -->
  

  <!-- End Navbar -->
</template>
<script>
//import UserDropdownComponent from "./UserDropdown.vue";
//import EventBus from "@/event-bus.js";
//import User from "@/models/User";
import { mapState } from "vuex";

export default {
  name: "Navbar",
  computed: {
    ...mapState("notification", ["notifications"]),
    user() {
      //return User.find(1);
      //return User.all()
      return this.$store.state.auth.user;
    },
  },
  methods: {
    logout() {
      this.$store
        .dispatch("auth/logout")
        .then(() => {
          this.$router.push({ name: "user-login" });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  mounted() {
  /*  
    var self = this;
    EventBus.$on("logout", function() {
      self.logout();
    });
  */
  },
};
</script>
